module.exports = __webpack_public_path__ + "static/img/fine.e50a4ddc.png";